import clsx from 'clsx'
import React from 'react'
import { Logger } from 'wdc-cube'
import { bindUpdate, ViewSlot } from 'wdc-cube-react'

import { makeStyles } from 'tss-react/mui'

import { Box, Grid } from '@mui/material'

import { classToFComponent, FCClassContext } from 'src/utils/views'
import ExportDocumentsDialog from 'src/components/exportdocuments/export_documents_dialog'
import { HistoryQueryFilter, UserProfileScope } from '../up_scopes'
import ChartConsumoFranquiaView from './components/chart_consumo_franquia'
import UserProfileFilters from './components/filters'
import UserProfileHistoryTable from './components/history_table'
import UserProfile from './components/profile'

const LOG = Logger.get('UserProfile-VIEW')

const useStyles = makeStyles()({
    view: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        minHeight: 600,
        rowGap: 10
    },
    cnpjInput: {
        flexGrow: 1
    },
    syncButton: {
        alignSelf: 'center'
    },
    min600Height: {
        minHeight: 600
    }
})

type UserProfileViewProps = {
    className?: string
    scope: UserProfileScope
}

class UserProfileClass implements FCClassContext<UserProfileViewProps> {
    // :: emissors
    readonly emitFind = (data: Partial<HistoryQueryFilter>) => {
        const filter = { ...this.scope.filterScope.filters, ...data }
        this.scope.filterScope.onFind(filter).catch(LOG.caught)
    }

    readonly emitOpenGroupProfile = (groupId: number) => {
        this.scope.onOpenGroupProfile(groupId).catch(LOG.caught)
    }

    readonly emitOpenChangePassword = () => {
        this.scope.onOpenChangePassword().catch(LOG.caught)
    }

    // :: Fields
    scope!: UserProfileScope
    sytles!: ReturnType<typeof useStyles>
    nameFilterInputRef!: React.RefObject<HTMLInputElement | null>

    // :: Methods

    onSyncState({ scope }: UserProfileViewProps) {
        this.scope = scope
        this.sytles = useStyles()
    }

    render({ className, scope }: UserProfileViewProps) {
        this.scope = bindUpdate(React, scope)
        this.nameFilterInputRef = React.useRef<HTMLInputElement>(null)
        const classes = this.sytles.classes

        if (scope.profileScope.waiting) {
            return <ViewSlot scope={scope.profileScope.waiting} />
        }

        return (
            <div className={clsx(classes.view, className)}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'baseline',
                        gap: '10px'
                    }}
                >
                    <Grid
                        container
                        sx={{
                            mb: 1
                        }}
                    >
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <UserProfile
                                scope={scope.profileScope}
                                handleOpenGroupProfile={this.emitOpenGroupProfile}
                                handleOpenChangePassword={this.emitOpenChangePassword}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <UserProfileFilters filterScope={scope.filterScope} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <ChartConsumoFranquiaView className={classes.min600Height} scope={scope.chartScope} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <UserProfileHistoryTable scope={scope.historyScope} filterScope={scope.filterScope} />
                        </Grid>
                    </Grid>
                </Box>
                <ExportDocumentsDialog scope={scope.exportDocsScope} />
            </div>
        )
    }
}

export const UserProfileView = classToFComponent(UserProfileClass, React)
export default UserProfileView
